package com.neurobs.ccabserver.administrator.components

import com.neurobs.ccab.CCABServer
import com.neurobs.ccabserver.administrator.contexts.MenuState.MenuItemType
import com.neurobs.ccabserver.administrator.contexts.{GuiContext, LoggerContext, MenuState, RecordCacheContext, ServerContext, UserContext}
import com.neurobs.ccabserver.administrator.controller.{AccountController, AdminController, AdminControllerAdapter, DataPasswordCache, StudyListController, SubjectListAdapter}
import com.neurobs.ccabserver.transcriptreview.TranscriptReviewToolCard
import com.neurobs.errors.Result
import com.neurobs.js.controller.AdminPanelAdapter
import com.neurobs.js.dom.ElementFactory
import com.neurobs.react.{AlignedLine, Button, Card, CardContentProvider, CardDeck, StyleUtil, includeIf}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.{React, ReactElement}
import slinky.core.facade.Hooks.{useEffect, useState}
import slinky.web.html.{className, div, key, p, ref, style}
import org.scalajs.dom

import scala.concurrent.{Future, Promise, blocking}
import scala.scalajs.js.timers.setTimeout
import scala.concurrent.ExecutionContext.Implicits.global
import scala.concurrent.duration.DurationInt

class TestCard(val canClose: Boolean) extends CardContentProvider {
	val title = "Test Card"

	var counter = 0

	override def refreshFunction: Option[CCABServer => Future[Result[AnyRef]]] = Some(server => {
		val promise = Promise[Result[AnyRef]]()
		setTimeout(2.seconds) {
			counter += 1
			val res: Result[AnyRef] = if (counter % 2 == 0) Left("Error message.") else Right("This is the content")
			promise.success(res)
		}
		promise.future
	}
	)
	def content(d: CardContentProvider.Delegate, contentData: Option[AnyRef]): ReactElement = {
		div(
		p(contentData.map(_.asInstanceOf[String]).getOrElse(""): String),
		Button(caption = "Add", onClick = () => {
			d.addCard(new TestCard(canClose = true), afterThis = true)
		})
		)
	}
}

@react object ItemContent {
	case class Props
	(
		selection: MenuItemType.Value
	)

	val component = React.memo(
		FunctionalComponent[Props] { props =>
			val user = UserContext.accessState()
			val recordCache = RecordCacheContext.accessState()
			val gui = GuiContext.accessState()
			val server = ServerContext.accessState()

			props.selection match {
				case MenuItemType.TestStations =>
					CardDeck.View(defaultCard = TestStationListCard)
				case MenuItemType.Reviews =>
					TranscriptReviewToolCard()
				case MenuItemType.Admin =>
					AdminControllerAdapter()
				case MenuItemType.Subjects =>
					SubjectListAdapter()
				case MenuItemType.Account =>
					CardDeck.View(defaultCard = new AdminPanelAdapter(new AccountController(isAccountAdmin = user.user.get.isAccountAdmin(user.user.get.legacyAccountId), accountId = user.user.get.legacyAccountId, currentUserId = user.user.get.legacyUserId, primaryEmail = "Email", server = server, cache = recordCache, gui = gui, legacy = false)))
				case MenuItemType.Studies =>
					CardDeck.View(defaultCard = new AdminPanelAdapter(StudyListController(gui = gui, accountId = user.user.get.legacyAccountId, accountName = "", dataPassword = user.value.dataPasswords, userData = user.user.get, addPanel = _ => Unit, legacy = false)(server)))
				case MenuItemType.Results =>
					ResultsStudyListContainer()
				case _ =>
					CardDeck.View(defaultCard = new TestCard(canClose = false))
			}
		},
		(prevProps: Props, nextProps: Props) => prevProps == nextProps
	)
}

@react object ContentArea {
	case class Props
	(
		selection: Option[MenuItemType.Value]
	)

	val component = React.memo(FunctionalComponent[Props] { props =>
		val user = UserContext.accessState()

		val (shownIndicators, setShownIndicators) = useState(MenuItemType.values.map(t => t -> false).toMap)

		useEffect(() => {
				props.selection foreach { s =>
					if (!shownIndicators(s)) {
						setShownIndicators(shownIndicators + (s -> true))
					}
				}
			},
			props.selection
		)

		//println("ContentArea rerender")
		div(
			shownIndicators.toSeq map { s =>
				val isSelection = Some(s._1) == props.selection
				div(
					className := (if (isSelection) "" else "nfw-hidden-container"),
					key := s._1.toString
				)(
					includeIf(isSelection || s._2)(ItemContent(s._1))
				)
			}
		)
	}, (prevProps: Props, nextProps: Props) => prevProps == nextProps)
}
